import api from "../api/axios";

export type HlsUploadResponse = {
  videoId: string;
  keyId?: string | null;
  posterUrl?: string | null;
  hlsUrl?: string | null;
  dashUrl?: string | null;
};

export default async function uploadViaBackendHls(
  file: File
): Promise<HlsUploadResponse> {
  const form = new FormData();
  form.append("file", file);

  const res = await api.post("/file-crypt/encrypt", form);

  const {
    videoId,
    keyId = null,
    posterUrl = null,
    hlsUrl = null,
    dashUrl = null,
  } = res.data || {};

  if (!videoId) {
    throw new Error("❌ Encryption failed: missing videoId");
  }

  return {
    videoId,
    keyId,
    posterUrl,
    hlsUrl,
    dashUrl,
  };
}